function acceptCookies(key) {
  document.getElementById('cookie-popup').style.display = 'none';
  localStorage.setItem('acceptedCookies:' + key.toString(), true);
}

function declineCookies(key) {
  document.getElementById('cookie-popup').style.display = 'none';
  localStorage.setItem('acceptedCookies:' + key.toString(), false);
}
